module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAA7ElEQVRYR+2WIQ7CQBREZ67BaUCCQaJBEI5R8NwBhcaBoycgaI6BQSCmWUITKC3ZNPu7FVvddF7/zsx+IvLDyPpIAF8TkLQEMOjgWPYkb06nCqAOxJ1ETnJUB7ACMDOGeJCclBrJhGkCFjF0Ds+dySRlAA4kr03GtojhmmQmaQjgDOAOYENyWwdhNoEPgFL3RHJchTAzYQ2A034CmJI8mvdAA0CpOye5+2nCkA3YV4D/RxDoNnzFsJUJJYW4DfsRw3cRLQBcvIsopAl9v2XWAwmg1QQkxV3JAsXQ5+cbl9K4a7kPeuh3UgyjT6AA9CFyISwhi9UAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/menu_zhankai_w.png
// module id = v7nh
// module chunks = 171